<div class="video-player my-3">
  <iframe [src]="src" allowfullscreen></iframe>
</div>
